var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_setup.isMobile
    ? _c(_setup.InfoLayout, {
        attrs: {
          "current-path": _setup.reverseFull({ name: "rate_fraud_free" }),
          "is-policy": false,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [
                  _vm._v(
                    "\n    " +
                      _vm._s(_setup.t("Отзывы без обмана", _setup.options)) +
                      "\n  "
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [_c(_setup.RateFraudFreeContent)]
              },
              proxy: true,
            },
          ],
          null,
          false,
          3925622926
        ),
      })
    : _c(_setup.RateFraudFreeContent)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }